var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card-footer',{attrs:{"footer-bg-variant":_vm.footerBgColor,"footer-text-variant":_vm.footerTextColor,"footer-class":_vm.footerClass}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }